import BaseOptionsModel from '../base_options_model';

class ReminderSettingsModel extends BaseOptionsModel {

    init(params) {
        this._title = 'App Settings';
        this._initOptions(params)
    }


    _initOptions(params = {}) {
        this._options = params;
    }


    /**
     * set / update selected interval in the model
     * if there is no such interval, this interval will not be set
     *
     * @param {string} value
     * @returns
     */
    setOptions(options) {
        let isStored = false;
        if (options) {
            this._options.reminder = options.reminder;
            isStored = true;
        }

        return isStored;
    }


    /**
     * @param {string} value
     * @returns
     */
    getOptions() {
        return {reminder: this._options.reminder}
    }
}

export default ReminderSettingsModel

